module.exports = __webpack_public_path__ + "static/media/ICONS-BABY_WORLD.39be2066.svg";